import { useQuery } from "react-query";
import { Auth } from "shared/@auth/Auth";

export function useStockGet() {
  const { makeAuthedRequest } = Auth.useContainer();

  const { data, isLoading, isError, refetch } = useQuery(
    ["stock"],
    () =>
      makeAuthedRequest(`stock`, {
        method: "GET",
      }).then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const body = await res.json().catch(() => ({}));
          throw new Error(body.message || `stock fetch failed: ${res.status}`);
        }
      }),
    {
      retry: false,
      onError: (err) => console.warn("useStockGet error:", err.message),
    }
  );

  return {
    data: data ?? [],
    isLoading,
    isError,
    refetch,
  };
}
